module.exports = __webpack_public_path__ + "assets/img/jenkins_secret_key_binding.adf98cef.png";